<template>
  <div class="scene_control_page">
    <div class="scene_control_title">提示</div>
    <div class="scene_control_name z_ellipsis1">
      要执行的场景：{{ objData.sceneName }}
    </div>
    <!-- <div class="scene_control_text">场景确认操作？</div> -->
    <div class="scene_control_btn">
      <span class="scene_btn public_control_btn" @click="clickCancelBtnHandle"
        >取消</span
      >
      <span class="scene_btn public_control_btn" @click="clickOkBtnHandle"
        >确认</span
      >
    </div>
    <!-- 场景控制 -->
  </div>
</template>

<script>
import store from 'store/index' ///导入公共仓库

export default {
  props: {
    objData: Object ///要控制场景的数据
  },

  methods: {
    clickOkBtnHandle() {
      console.log('确定按钮被点击了')
      this.$request({
        method: 'post',
        url: '/userScene/controllerScene',
        data: {
          sceneId: this.objData.sceneId,
          token: store.state.token
        }
      })
        .then(res => {
          this.$closeControlToast() ///关闭toast控制弹窗

          this.$toast(res.data.message, 3000) ///服务端返回信息

          console.log(res)
        })
        .catch(err => {
          console.log('发送失败')
        })
    },
    clickCancelBtnHandle() {
      this.$closeControlToast() ///关闭toast控制弹窗
    }
  }
}
</script>

<style>
.scene_control_page {
  width: 330px;
  height: 180px;

  position: relative;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: center;
  /* align-content: center; */
  align-items: center;
}
.scene_control_title {
  font-size: 20px;
  margin: 10px 0;
  width: 100%;
  text-align: center;
}

.scene_control_name {
  width: 100%;
  color: #999999;
  margin: 10px 0;
  text-align: center;
}
.scene_control_btn {
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;

  margin: 20px 0;
}
.scene_btn {
  flex: 1;
  margin: 0px 25px;
  background: #f5f5f5;
  color: #282828;
}
/* .scene_btn:active {
  background: #a0a3a5;
  border: 0px solid #a0a3a5;
} */
</style>
